<template>
  <div>
    <div>
      <v-layout row align-center>
        <v-icon x-large color="primary">mdi-calendar-text</v-icon>
        <h1>Tournament Schedule</h1>
      </v-layout>
    </div>
    <v-expansion-panels focusable hover>
      <v-expansion-panel v-for="event in events" v-bind:key="event.id">
        <v-expansion-panel-header>
          <v-row>
            <v-col cols="12" xl="3" lg="3" md="3" sm="6">
              <div>{{ event.title }}</div>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="6">
              <div>Start: {{ convertDate(event.eventStart, true) }}</div>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="6">
              <div>End: {{ convertDate(event.eventEnd, false) }}</div>
            </v-col>
            <v-col cols="12" xl="2" lg="2" md="2" sm="6">
              <div
                class="button"
                v-if="canSignup(event.signUpStart, event.signUpEnd)"
              >
                <v-btn @click="onPay(event)" outlined @click.native.stop>
                  <v-icon left>mdi-login-variant</v-icon>Pay for tournament
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="primary">
          <v-card class="top">
            <v-card-text>
              <v-row>
                <v-col cols="12" lg="6" md="6" sm="12">
                  <div>
                    <strong>Description:</strong> {{ event.description }}
                  </div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12">
                  <div><strong>Entry Fee:</strong> ${{ event.entryFee }}</div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12">
                  <div><strong>Course:</strong> {{ event.course }}</div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12">
                  <div><strong>Start:</strong> {{ event.start }}</div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12">
                  <div>
                    <strong>Event Start:</strong>
                    {{ convertDate(event.eventStart, true) }}
                  </div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12">
                  <div>
                    <strong>Event End:</strong>
                    {{ convertDate(event.eventEnd, false) }}
                  </div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12">
                  <div>
                    <strong>Signup Start:</strong>
                    {{ convertDate(event.signUpStart, true) }}
                  </div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="12">
                  <div>
                    <strong>Signup End:</strong>
                    {{ convertDate(event.signUpEnd, true) }}
                  </div>
                </v-col>
                <v-col cols="12" lg="12" md="12" sm="12">
                  <div>
                    {{ getSignupMessage(event.signUpStart, event.signUpEnd) }}
                  </div>
                </v-col>
              </v-row>
              <v-row
                v-if="
                  canSignup(event.signUpStart, event.signUpEnd) || priviledged
                "
              >
                <v-col cols="12">
                  <v-card>
                    <v-card-actions>
                      <v-row>
                        <v-spacer></v-spacer>
                        <div v-if="priviledged">
                          <v-btn outlined @click="onAddDocument(event.eventId)">
                            <v-icon left>mdi-text-box-plus-outline</v-icon>Add
                            Document
                          </v-btn>
                        </div>
                        <div v-if="priviledged">
                          <v-btn outlined @click="onEditEvent(event.eventId)">
                            <v-icon left>mdi-pencil</v-icon>Edit
                          </v-btn>
                        </div>
                        <div v-if="priviledged">
                          <v-btn
                            outlined
                            :disabled="event.eventDocuments.length > 0"
                            @click="onDeleteEvent(event.eventId)"
                          >
                            <v-icon left>mdi-delete</v-icon>Delete
                          </v-btn>
                        </div>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <documents :event="event"></documents>
                </v-col>
              </v-row>
              <v-row v-if="priviledged">
                <v-col cols="12">
                  <deletedocuments
                    :event="event"
                    :events="events"
                    @documentdeleted="onDocumentDeleted"
                  ></deletedocuments>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="priviledged" color="primary">
        <v-expansion-panel-header>
          <div>Add Tournament</div>
          <v-spacer></v-spacer>
          <div></div>
          <v-spacer></v-spacer>
          <div>
            <v-btn @click="onAddEvent()" outlined @click.native.stop>
              <v-icon left>mdi-plus</v-icon>Add
            </v-btn>
          </div>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title>{{ deleteMessage }}</v-card-title>
          <v-card-text>{{ title }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined text @click="dialog = false">No</v-btn>
            <v-btn outlined text @click="deleteEvent">Yes</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <statusalert ref="alert" returnUrl="/schedule"></statusalert>
  </div>
</template>

<script>
import EventsService from '../../services/api/EventsService.js'
import DateService from '../../services/manager/DateService.js'
import store from '@/store/index.js'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'
import documents from '../../components/Documents'
import deletedocuments from '../../components/DeleteDocuments'

export default {
  name: 'Schedule',
  components: {
    deletedocuments,
    documents,
    statusalert,
  },
  store: store,
  data() {
    return {
      dialog: false,
      deleteMessage: 'Delete the selected event?',
      eventId: 0,
      events: [],
      years: [],
      course: 'Peak/Plains',
      start: 'Tee Times',
      title: 'Individual Low Gross, Low Net',
      entryFee: 99,
      eventStart: new Date().toISOString().substring(0, 10),
      eventEnd: new Date().toISOString().substring(0, 10),
      signupStart: new Date().toISOString().substring(0, 10),
      signupEnd: new Date().toISOString().substring(0, 10),
      eventStartTime: '07:00',
      eventEndTime: '16:00',
      signupStartTime: '06:00',
      signupEndTime: '06:00',
    }
  },

  created() {
    this.fetchEvents()
  },
  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    },
  },
  methods: {
    fetchEvents() {
      store.commit('isLoading')

      EventsService.get()
        .then((events) => {
          this.events = events
          this.sortEvents()
        })
        .catch((error) => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },
    onAddDocument(eventId) {
      router.push('/documents/edit/0?eventId=' + eventId)
    },
    onDocumentDeleted() {
      this.fetchEvents()
    },
    sortEvents() {
      var today = new Date()
      today.setDate(today.getDate() - 3)
      var events = []
      this.events.forEach((event) => {
        var startDate = new Date(event.eventStart)
        if (startDate > today) {
          events.push(event)
        }
      })
      this.events = events
    },

    convertDate(dateString, full) {
      return DateService.convertDate(dateString, full)
    },

    onDeleteEvent(eventId) {
      this.deleteMessage = 'Delete the selected event?'
      this.dialog = true
      // find the event
      const event = this.events.find((e) => e.eventId === eventId)
      this.title = ''
      this.eventId = 0
      if (event) {
        this.eventId = event.eventId
        this.title = event.title
      }
    },

    deleteEvent() {
      this.dialog = false
      if (this.eventId > 0) {
        EventsService.delete(this.eventId)
          .then((result) => {
            this.$refs.alert.displayResult(result)
          })
          .catch((error) => console.log(error))
          .finally(() => {
            store.commit('notLoading')
            this.fetchEvents()
          })
      }
    },

    onGreenFees() {
      window.open('https://www.pattyjewettgolfshop.com/patty-jewett-mens-golf-association/', '_blank')
    },

    onPay(event) {
      router.push('/schedule/pay/' + event.eventId)
    },

    onSignUp() {
      window.open('https://www.unknowngolf.com/')
    },

    onAddEvent() {
      router.push('/schedule/edit/0')
    },

    onEditEvent(eventId) {
      router.push('/schedule/edit/' + eventId)
    },

    canSignup(startDate, endDate) {
      return EventsService.canSignup(startDate, endDate)
    },

    parseDate(theDate) {
      if (theDate !== undefined) {
        var re = /-?\d+/
        let m = re.exec(theDate)
        return new Date(parseInt(m[0], 10))
      } else {
        return ''
      }
    },

    getSignupMessage(startDate, endDate) {
      return EventsService.getSignupMessage(startDate, endDate)
    },
  },
}
</script>
<style lang="scss" scoped>
.top {
  margin-top: 15px;
}
</style>
